import { uiConfig } from './theme/brand'

export default defineAppConfig({
  ui: uiConfig,

  host: '',
})
